import script from "./SupplierRequirementValuesView.vue?vue&type=script&setup=true&lang=ts"
export * from "./SupplierRequirementValuesView.vue?vue&type=script&setup=true&lang=ts"

import "./SupplierRequirementValuesView.vue?vue&type=style&index=0&id=072122d5&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072122d5"]])

export default __exports__